<!-- src/containers/TheContainer.vue -->
<template>
  <div class="app-shell">
    <AppHeader />
    <!-- <AppSidebar /> -->

    <main class="app-main">
      <div class="app-content" >
         <img v-if="isHome" src="/banner02.png" alt="banner" style="width: -webkit-fill-available;" />
        <router-view v-else />
      </div>
    </main>

    <footer v-if="showFooter" class="app-footer text-center" aria-label="App footer">
      <a href="/" class="powered-by" aria-label="Go to home">
        Powered by
        <img src="/logo.png" alt="logo" class="brand-logo" loading="lazy" />
      </a>
    </footer>
  </div>
</template>

<script>
import AppHeader from './TheHeader.vue'
export default {
  name: 'TheContainer',
  components: { AppHeader },
  computed: {
    // ซ่อนไปใน route ที่ไม่ต้องมี footer: meta: { hideFooter: true }
    showFooter() {
      return !(this.$route?.meta && this.$route.meta.hideFooter)
    },
    isHome() {
      return this.$route.path === '/'
    }
  },
}
</script>

<style scoped>
/* โครงหลัก + รองรับมือถือ (dynamic viewport + safe-area) */
.app-shell {
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  background:
    radial-gradient(1200px 500px at 10% -10%, rgba(13,110,253,.06), transparent),
    radial-gradient(1200px 500px at 110% 110%, rgba(25,135,84,.06), transparent),
    linear-gradient(180deg, #f8fafc 0%, #ffffff 100%);
}

.app-main {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
}

/* เนื้อหายืดเต็มความสูงที่เหลือ (ทำให้ footer ติดล่าง) */
.app-content {
  flex: 1 1 auto;
  padding-top: env(safe-area-inset-top);
  padding: 0px;
}

/* Footer เรียบ ๆ รองรับ safe-area */
.app-footer {
  padding: 12px clamp(12px, 2vw, 24px) max(12px, env(safe-area-inset-bottom));
  color: #6c757d;
  border-top: 1px solid rgba(0,0,0,.05);
  backdrop-filter: saturate(140%) blur(6px);
  background: rgba(255,255,255,.75);
}

.powered-by {
  display: inline-flex;
  align-items: center;
  gap: .5rem;
  font-size: .95rem;
  text-decoration: none;
  color: inherit;
}

.brand-logo {
  height: 22px;
  width: auto;
  display: inline-block;
  vertical-align: middle;
  filter: drop-shadow(0 1px 1.5px rgba(0,0,0,.08));
  opacity: .95;
}

@media (min-width: 992px) {
  .brand-logo { height: 24px; }
}

/* ตัวช่วย: ถ้ายังอยากใช้ .min-vh-90 จริง ๆ สร้าง utility นี้ไว้ใช้ได้ */
.min-vh-90 { min-height: 90vh; }


</style>
